import NotificationFactory from "../notifications/notificationFactory";
import OnFlowError from '~/models/processFlows/onFlowError';
import Notification from '~/models/notifications/notification';
import { DefaultEmailStyle } from '~/enums/defaultEmailStyle';
import { NotificationDeliveryMethod } from '~/enums/notificationDeliveryMethod';

export default class OnFlowErrorNotificationFactory extends NotificationFactory {
  static create(parent: OnFlowError) {
    const notification: Notification = super.create(parent, Notification);

    notification.show_delivery_methods = false;
    notification.delivery_methods = [NotificationDeliveryMethod.ViaEmail];
    notification.email_style = DefaultEmailStyle.Formability;

    return notification;
  }
}